import { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import WhatsAppVerify from "./WhatsAppVerify";
import "./privateGroupNudge.css";

/**
 * D4 — a targeted nudge. Someone whose number is in a private WhatsApp group's
 * roster, but who hasn't verified, is missing that group's rides in the app. This
 * banner tells them, and lets them verify without leaving the feed.
 *
 * Only appears when the server confirms a real match (best-effort, phone-number
 * based) — so it's silent for everyone else, unlike the generic onboarding nudge.
 */
function PrivateGroupNudge({ loginUser }) {
  const [groups, setGroups] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!loginUser || !loginUser._id || loginUser.whatsappVerified === true) return;
    let alive = true;
    axios
      .get("/api/v1/user/whatsapp/private-nudge")
      .then((res) => { if (alive) setGroups(res.data?.groups || []); })
      .catch(() => { /* best-effort — a failed nudge just shows nothing */ });
    return () => { alive = false; };
  }, [loginUser]);

  if (dismissed || !groups.length) return null;

  const label =
    groups.length === 1
      ? `Rides from “${groups[0]}” are hidden`
      : `Rides from ${groups.length} of your WhatsApp groups are hidden`;

  const handleVerified = () => {
    try {
      const lu = JSON.parse(localStorage.getItem("loginUser")) || {};
      lu.whatsappVerified = true;
      localStorage.setItem("loginUser", JSON.stringify(lu));
    } catch (e) { /* non-critical */ }
    window.location.reload();
  };

  return (
    <div className="sr-pgn">
      <div className="sr-pgn__bar">
        <span className="sr-pgn__icon"><FontAwesomeIcon icon={faWhatsapp} /></span>
        <div className="sr-pgn__text">
          <strong>{label}</strong>
          <span> — verify your WhatsApp to see rides shared in your private groups.</span>
        </div>
        {!expanded && (
          <div className="sr-pgn__actions">
            <button className="sr-pgn__verify" onClick={() => setExpanded(true)}>Verify</button>
            <button className="sr-pgn__dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss">✕</button>
          </div>
        )}
      </div>
      {expanded && (
        <div className="sr-pgn__panel">
          <WhatsAppVerify
            title="Verify to unlock your group rides"
            subtitle="Send the code from the number that's in your WhatsApp group — we never message you first."
            autoStart
            onVerified={handleVerified}
          />
          <button className="sr-pgn__cancel" onClick={() => setExpanded(false)}>Not now</button>
        </div>
      )}
    </div>
  );
}

export default PrivateGroupNudge;
